import { render, staticRenderFns } from "./LoadMoreButton.vue?vue&type=template&id=fb48ddfe&scoped=true&lang=pug&"
import script from "./LoadMoreButton.vue?vue&type=script&lang=js&"
export * from "./LoadMoreButton.vue?vue&type=script&lang=js&"
import style0 from "./LoadMoreButton.vue?vue&type=style&index=0&id=fb48ddfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb48ddfe",
  null
  
)

export default component.exports